import React from 'react'
import type { LucideIcon } from 'lucide-react'

interface EmptyStateProps {
  title: string
  description: string
  icon: LucideIcon
  actionLabel?: string
  onAction?: () => void
}

const EmptyState: React.FC<EmptyStateProps> = ({
  title,
  description,
  icon: Icon,
  actionLabel,
  onAction,
}) => {
  return (
    <div className="relative flex flex-col items-center justify-center py-16 px-6 text-center">
      {/* Decorative background circles */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-64 h-64 rounded-full bg-acad-50 opacity-50" />
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-48 h-48 rounded-full bg-acad-100 opacity-30" />
      </div>

      {/* Content */}
      <div className="relative z-10 flex flex-col items-center">
        <div className="w-16 h-16 rounded-2xl bg-acad-200 flex items-center justify-center mb-5">
          <Icon className="w-8 h-8 text-acad-500" />
        </div>

        <h3 className="text-lg font-semibold text-gray-900 mb-2">{title}</h3>
        <p className="text-sm text-gray-500 max-w-sm">{description}</p>

        {actionLabel && onAction && (
          <button
            onClick={onAction}
            className="mt-6 inline-flex items-center gap-2 px-5 py-2.5 bg-acad-500 text-white
                       rounded-lg text-sm font-medium hover:bg-acad-600 transition-colors
                       shadow-sm"
          >
            {actionLabel}
          </button>
        )}
      </div>
    </div>
  )
}

export default EmptyState
